import { render, staticRenderFns } from "./HomeMasasArtesanales.vue?vue&type=template&id=1b94228d&scoped=true"
import script from "./HomeMasasArtesanales.vue?vue&type=script&lang=js"
export * from "./HomeMasasArtesanales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94228d",
  null
  
)

export default component.exports